import React from "react";
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  Platform,
  TouchableOpacity,
} from "react-native";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";

interface AdminWelcomeCardProps {
  title: string;
  onBackClick?: () => void;
  testID?: string;
}

const AdminWelcomeCard: React.FC<AdminWelcomeCardProps> = ({
  title,
  onBackClick,
  testID = "admin-welcome-card",
}) => {
  // Helper function to check if device is in mobile layout
  const [, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkIfMobile = () => {
      const windowWidth = Dimensions.get("window").width;
      setIsMobile(
        Platform.OS === "ios" || Platform.OS === "android" || windowWidth < 768
      );
    };

    // Initial check
    checkIfMobile();

    // Add event listener for window resize (Web only)
    if (Platform.OS === "web") {
      window.addEventListener("resize", checkIfMobile);
    }

    // Clean up
    return () => {
      if (Platform.OS === "web") {
        window.removeEventListener("resize", checkIfMobile);
      }
    };
  }, []);

  return (
    <View style={styles.welcomeCard} testID={testID}>
      <View style={styles.welcomeContainer}>
        <View style={styles.welcomeLeftContent}>
          <MaterialIcons name="settings" size={24} color="#0066cc" />
          <Text style={styles.welcomeText}>{title}</Text>
        </View>
        {/* Back Button - using TouchableOpacity like in LeadershipWalkHeader */}
        <View style={styles.buttonRow} testID={`${testID}-buttons`}>
          {onBackClick && (
            <TouchableOpacity
              style={styles.backButton}
              onPress={onBackClick}
              testID={`${testID}-back-button`}
            >
              <Text style={styles.buttonIcon}>←</Text>
              {Platform.OS === "web" ? (
                <Text style={styles.buttonText}>Back to Dashboard</Text>
              ) : null}
            </TouchableOpacity>
          )}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  welcomeCard: {
    backgroundColor: "white",
    borderRadius: 8,
    marginTop: 16,
    marginBottom: 16,
    borderLeftWidth: 4,
    borderLeftColor: "#0066CC",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 3,
    elevation: 2,
  },
  welcomeContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16,
    flexWrap: "wrap",
  },
  welcomeLeftContent: {
    flexDirection: "row",
    alignItems: "center",
  },
  welcomeText: {
    fontSize: 24,
    fontWeight: "500",
    color: "#FFFFFF",
    marginLeft: 12,
  },
  buttonRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
    alignItems: "center",
  },
  buttonRowMobile: {
    marginTop: 16,
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    gap: 10,
  },
  actionButton: {
    width: Platform.OS === "web" ? "auto" : 160,
    minWidth: 160,
    alignSelf: "center",
    marginVertical: 5,
  },
  backButton: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#0066CC",
    paddingHorizontal: Dimensions.get("window").width < 600 ? 12 : 16,
    paddingVertical: Dimensions.get("window").width < 600 ? 8 : 10,
    borderRadius: 6,
    flexShrink: 0,
  },
  buttonIcon: {
    color: "white",
    fontSize: Dimensions.get("window").width < 600 ? 14 : 16,
    marginRight: 4,
  },
  buttonText: {
    color: "white",
    fontSize: Dimensions.get("window").width < 600 ? 12 : 14,
    fontWeight: "500",
  },
});

export default AdminWelcomeCard;
